import { api, unwrap } from './client';
import { payoutFromApi, payoutOverviewFromApi } from './_transforms';

export async function getPayoutOverview() {
  const data = await unwrap(api.get('/api/payouts/overview'));
  return payoutOverviewFromApi(data);
}

export async function listPayouts() {
  const data = await unwrap(api.get('/api/payouts'));
  return (data || []).map(payoutFromApi);
}

// Step 1 — the backend e-mails a 6-digit code and returns the challenge.
export function requestPayoutOtp({ amount, note }) {
  return unwrap(api.post('/api/payouts/request-otp', { amount, note: note || null }));
}

// Step 2 — the payout may already come back FAILED if the gateway refused it.
export async function confirmPayout({ challengeId, code }) {
  const data = await unwrap(api.post('/api/payouts/confirm', { challengeId, code }));
  return payoutFromApi(data);
}

export async function recheckPayout(id) {
  const data = await unwrap(api.post(`/api/payouts/${id}/recheck`));
  return payoutFromApi(data);
}

export function requestPayoutNumberOtp({ msisdn, name, providerId }) {
  return unwrap(api.post('/api/payouts/number/request-otp', { msisdn, name, providerId: providerId || null }));
}

export async function confirmPayoutNumber({ challengeId, code }) {
  const data = await unwrap(api.post('/api/payouts/number/confirm', { challengeId, code }));
  return payoutOverviewFromApi(data);
}
